import { useState } from 'react';
import './CustomBox.css';

interface CustomBoxProps {
  timeSlots: string[];
  onSlotSelect: (time: string | null) => void;
}

export default function CustomBox({ timeSlots, onSlotSelect }: CustomBoxProps) {
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);

  const handleSelectSlot = (time: string) => {
    setSelectedSlot(time);
    onSlotSelect(time);
  };

  return (
    <div className="time-slot-grid">
      {timeSlots.map((time, index) => (
        <button
          key={index}
          className={`time-slot-button ${selectedSlot === time ? 'selected' : ''}`}
          onClick={() => handleSelectSlot(time)}
        >
          {time}
        </button>
      ))}
    </div>
  );
}
